import { FC, useState, useEffect } from 'react';
import { UseFormReturn, useForm } from 'react-hook-form';
import { LessonFormData, QuizQuestion } from './types';
import { BasicFields } from './BasicFields';
import { QuizSection } from './QuizSection';

interface LessonFormFieldsProps {
  form?: UseFormReturn<LessonFormData>;
  initialQuestions?: QuizQuestion[];
}

export const LessonFormFields: FC<LessonFormFieldsProps> = ({ form: externalForm, initialQuestions = [] }) => {
  const defaultForm = useForm<LessonFormData>({
    defaultValues: {
      title: '',
      video_url: '',
      audio_url: '',
      content_text: '',
      level: 'beginner',
      published: false,
      is_premium: false,
      quiz_questions: [],
    }
  });

  const form = externalForm || defaultForm;
  const [questions, setQuestions] = useState<QuizQuestion[]>(initialQuestions);

  useEffect(() => {
    if (initialQuestions && initialQuestions.length > 0) {
      setQuestions(initialQuestions);
    }
  }, [initialQuestions]);

  const handleQuestionsChange = (newQuestions: QuizQuestion[]) => {
    setQuestions(newQuestions);
    form.setValue('quiz_questions', newQuestions);
  };

  return (
    <div className="space-y-8">
      <BasicFields form={form} />
      <QuizSection
        form={form}
        questions={questions}
        setQuestions={handleQuestionsChange}
      />
    </div>
  );
};